<div style="display: block">
    <canvas baseChart [data]="doughnutChartData" [labels]="doughnutChartLabels" [colors]="chartColors" [chartType]="doughnutChartType"></canvas>
</div>